<template>
    <div class='mt-5 mb-3'>
        <!--
        <header>{{ $t('departure_transfers.departure_transfer_groups') }}</header> -->

          <h4>
            <b-icon icon="box-arrow-in-right"></b-icon>
            <span>{{ $t('departure_transfers.departure_transfer_groups') }}</span>
            <a v-if="!selectedTransferGroup" href="#" class="action-link" @click="onNewItem" v-b-tooltip :title="$t('button.add')"><b-icon icon="plus-circle-fill" scale="1.0"></b-icon></a>
            <a v-else  href="#" class="action-link" @click="onReset" v-b-tooltip :title="$t('button.close')"><b-icon icon="x" scale="1.8"></b-icon></a>
         </h4>


        <div v-if="!selectedTransferGroup">
            <!-- <TableActionHeader @newItem="onNewItem" :searchInput="false" /> -->
            <div v-if="!items || items.length == 0" class='info note'>
                {{ $t('departure_transfers.empty') }}
            </div>
            <div v-else>
            <b-table
                style="white-space: pre-line;"
                small
                striped
                hover
                selectable
                select-mode="single"
                @row-selected="onRowSelected"
                :fields="fields"
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                thead-tr-class="departure-transfer-headtr"
                tbody-tr-class="departure-transfer-bodytr">
                <template v-slot:cell(state)="data">
                    <DepartureTransferState :startTime="data.item.startTime" :endTime="data.item.endTime" />
                </template>
                <template v-slot:cell(departureTransfers)="data">
                    <div v-for="transfer in data.value" :key="'dtg-'+data.item.departureTransferGroupId+'-'+transfer.departureTransferIds[0]">
                        {{ transfer.sourcePlatform +' ' }}<b-icon icon="arrow-right"></b-icon>{{ ' '+ transfer.destinationPlatform }}
                        <span v-if="transfer.lines && transfer.lines.length > 0">{{ transfer.lines[0] }}</span>
                    </div>
                </template>
            </b-table>
            <TablePagination 
                :total-rows="totalRows" 
                :per-page="perPage" 
                @pageChange="onPageChange">
            </TablePagination>
            </div>
        </div>
        <div v-else>
            <form>
                <b-table
                    small
                    striped
                    :fields="formFields"
                    :items="formItems"
                    thead-tr-class="departure-transfer-headtr"
                    tbody-tr-class="departure-transfer-bodytr">
                    <template v-slot:cell(departureTransferGroup)="data">
                        <input type="checkbox" v-model="selectedTransferGroup.departureTransferIds" :value="data.item.departureTransferIds[0]" :disabled="loading">
                    </template>
                </b-table>

                <!--
                <b-form-group :label="$t('departure_transfers.indefinite')">
                    <input type="checkbox" v-model="selectedTransferGroup.indefinite" :disabled="loading">
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.start_time')">
                    <DateTimePicker v-model="selectedTransferGroup.startTime" :disabled="selectedTransferGroup.indefinite || loading" />
                </b-form-group>
                <b-form-group :label="$t('departure_transfers.end_time')">
                    <DateTimePicker v-model="selectedTransferGroup.endTime" :disabled="selectedTransferGroup.indefinite || loading" />
                </b-form-group>
                -->
                
                <b-row>
                    <b-col>
                        <label>{{ $t('departure_transfers.start_time') }}</label>
                        <DateTimePicker v-model="selectedTransferGroup.startTime" :disabled="selectedTransferGroup.indefinite || loading" />
                    </b-col>
                    <b-col>
                        <label>{{ $t('departure_transfers.end_time') }}</label>
                        <DateTimePicker v-model="selectedTransferGroup.endTime" :disabled="selectedTransferGroup.indefinite || loading" />
                    </b-col>
                </b-row>
                
                <div class="mb-3">
                    <div class='float-right'>
                    <input type="checkbox" v-model="selectedTransferGroup.indefinite" :disabled="loading" style='margin-right: 8px;'>
                    <label> {{  $t('departure_transfers.indefinite') }} </label>
                    </div>
                </div>



                <FormButtons @submit="onSubmit" @reset="onReset" :remove="action == 'edit'" @remove="onRemove"></FormButtons>
                <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
            </form>
        </div>
    </div>
</template>

<script>
import terminalView from '@/store/terminals/terminalView';
import DepartureTransferState from '@/components/Terminals/DepartureTransferState.vue';
import moment from 'moment';
import TablePagination from '@/components/Misc/TablePagination'
import DateTimePicker from '@/components/Misc/DateTimePicker'

export default {
	name: 'DepartureTransferGroups',
    props: ['terminalId', 'activeTerminalId'],
    components: { TablePagination, DepartureTransferState, DateTimePicker },
    data: function() {
        return {
            ok: false,
            error: false,
            loading: false,
            infoType: 'save',
            perPage: 7,
            currentPage: 1,
            selectedTransferGroup: null
        };
    },
    computed: {
        fields() {
            return [
                { key: 'state' , label: this.$t('departure_transfers.state.table_header'), sortable: false },
                { key: 'departureTransfers' , label: this.$t('departure_transfers.group_transfers'), sortable: false },
                { key: 'active', label: this.$t('departure_transfers.active'), sortable: false, formatter: (value, key, item) => {
                        var time = new moment(item.startTime, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
                        if (time.startsWith('Invalid')) {
                            return this.$t('departure_transfers.indefinitely');
                        }
                        time += ' -\n';
                        var time2 = new moment(item.endTime, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm');
                        if (time2.startsWith('Invalid')) {
                            return this.$t('departure_transfers.indefinitely');
                        }
                        return time + time2;
                    }
                }
            ];
        },
        items() {
             return this.$store.state.terminalView.departureTransferGroupsByTerminal[this.terminalId];
        },
        formFields() {
            return [
                { key: 'sourcePlatform' , label: this.$t('departure_transfers.source_platform'), sortable: false },
                { key: 'destinationPlatform' , label: this.$t('departure_transfers.destination_platform'), sortable: false },
                { key: 'lines' , label: this.$t('departure_transfers.lines'), sortable: false, formatter: (value, key, item) => {
                    var lineList = '';
                    for (var line of item.lines) {
                        lineList += line;
                        lineList += ' ';
                    }
                    return lineList;
                }},
                { key: 'departureTransferGroup' , label: this.$t('departure_transfers.group_transfer'), sortable: false }
            ];
        },
        formItems() {
            var transferList = [];
            for (var transfer of this.$store.state.terminalView.departureTransfersByTerminal[this.terminalId]) {
                for (var i = 0; i < transfer.departureTransferIds.length; i++) {
                    var departureTransfer = { lines: [], departureTransferIds: [] };
                    departureTransfer.sourcePlatform = transfer.sourcePlatform;
                    departureTransfer.destinationPlatform = transfer.destinationPlatform;
                    departureTransfer.departureTransferIds.push(transfer.departureTransferIds[i]);
                    if (transfer.lines[i]) {
                        departureTransfer.lines.push(transfer.lines[i]);
                    }
                    transferList.push(departureTransfer);
                }
            }
            return transferList;
        },
        totalRows() {
            return this.items ? this.items.length : 0;
        }
    },
    methods: {
        onNewItem() {
            this.selectedTransferGroup = { departureTransfers: [], departureTransferIds: [] };
            this.selectedTransferGroup.terminalId = this.terminalId;
            this.selectedTransferGroup.indefinite = false;
            this.action = 'add';
        },
        onRowSelected(items) {
            if (items[0]) {
                this.selectedTransferGroup = { ...items[0] }; // Copy.
                this.action = 'edit';
            }
        },
        onReset() {
            this.selectedTransferGroup = null;
            this.ok = this.error = false;
            this.loading = this.disabled = false;
        },
        onSubmit(event) {
            if (event)
                event.preventDefault();
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = this.disabled = true;

            this.$store.dispatch('terminalView/saveDepartureTransferGroup', { departureTransferGroup: this.selectedTransferGroup,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = this.disabled = false;
                    if (response.data.errorCode == 0) {
                        this.selectedTransferGroup = null;
                    } else {
                        this.error = true;
                    }
                }, 1000);
            })
            .catch( () => { this.error = true; })
        },
        onRemove() {
            this.ok = this.error = false;
            this.infoType = "delete";
            this.loading = this.disabled = true;
            this.$store.dispatch('terminalView/deleteDepartureTransferGroup', { departureTransferGroup: this.selectedTransferGroup,
                                                                        terminalId: this.terminalId })
            .then(response => {
                setTimeout(() => { 
                    this.loading = this.disabled = false;
                    if (response.data.errorCode == 0) {
                        this.selectedTransferGroup = null;
                    } else {
                        this.error = true;
                    }
                }, 1000);
            }, () => {
                    this.ok = false;
                    this.error = !this.ok;
                    this.loading = this.disabled = false;
            });
        },
        onPageChange(page) {
            this.currentPage = page;
        }
    },
    watch: {
        activeTerminalId() {
            if (this.terminalId == this.activeTerminalId) {
                this.$store.dispatch('terminalView/getTerminalDepartureTransferGroups', this.terminalId);
            }
        }
    },
    created() {
        if (!this.$store.state.terminalView) {
            this.$store.registerModule("terminalView", terminalView);
        }
    }
}
</script>